<template>
  <div class="dataLeft l">
    <h4>
      <span>Dest.</span>
      <!-- <a @click="AllTrans('endCode3', 'endAirport')">All</a> -->
    </h4>
    <el-checkbox-group class="chkMode" v-model="endCode3" >
      <span class="transType" v-for="(item, index) in endAirport" :key="index">
        <el-checkbox :label="item" @change="sortQuery()" :disabled="endAirport.length<=1" :key="index">
          <span class="cksort">{{ item }}</span>
        </el-checkbox>
        <a class="onlyTrans" @click="onlyTrans('endCode3', item)" v-if="endAirport.length>1">Only</a>
      </span>
    </el-checkbox-group>

    <h4>
      <span>Origin</span>
      <a @click="AllTrans(3)">All</a>
    </h4>
    <el-checkbox-group class="chkMode" v-model="airlineOrigin">
      <span
        class="transType"
        v-for="(item, index) in airlineOriginList.slice(0,originNum)"
        :key="index"
      >
        <el-checkbox :label="item" :disabled="airlineOrigin.length<=1&&airlineOrigin==item" @change="val => queryAirLine(2,'')" :key="index">
          <span class="cksort">{{ item }}</span>
        </el-checkbox>
        <a class="onlyTrans" @click="queryAirLine(2, item)">Only</a>
      </span>
    </el-checkbox-group>

    <span class="moreClass" v-if="airlineOriginList.length>5"><!--v-if="startAirport.length>5"-->
      <a @click="clickMoreOri">
        {{showOrigin==true?'more':'stow'}}<i :class="showOrigin==true?'fa fa-arrDown colBlue':'fa fa-arrowUp colBlue'" style="margin-top: 1px"></i>
      </a>
    </span>

    <!-- <div v-if="thWorkDays.length > 0">
      <h4>
        <span>Timeliness of pick-up</span>
      </h4>
      <el-checkbox-group class="chkMode" v-model="thDays">
        <span
          class="transType"
          v-for="(item, index) in thWorkDays"
          :key="index"
        >
          <el-checkbox :label="item" @change="sortQuery" :key="item">
            <span class="cksort">{{ item }} Days</span>
          </el-checkbox>
        </span>
      </el-checkbox-group>
    </div> -->
    <h4><span>Route</span></h4>
    <span class="transType" style="padding: 10px 0 13px 20px">
      <el-checkbox @change="onlyRoute()" v-model="arrivalType">
        <span class="cksort">Direct only</span>
      </el-checkbox>
    </span>
    <!--新增Airline-->
    <h4>
      <span>Airline</span>
      <a @click="AllTrans(2)">All</a>
    </h4>
    <el-checkbox-group class="chkMode"  v-model="airlinelist">
    <span class="transType"  v-for="(item, index) in airlineCode2list.slice(0,toleNum)" :key="index" >
      <el-checkbox  :label="item.Code" :key="index" @change="val => queryAirLine(3,'')" :disabled="airlinelist.length<=1&&airlinelist==item.Code">
        <span class="cksort">{{item.Code}}</span>
      </el-checkbox>
      <a class="onlyTrans" @click="queryAirLine(3, item.Code)">Only</a>
    </span>

    </el-checkbox-group>
    <span class="moreClass" v-if="airlineCode2list.length>5">
      <a @click="clickMore">
        {{showMore==true?'more':'stow'}}<i :class="showMore==true?'fa fa-arrDown colBlue':'fa fa-arrowUp colBlue'" style="margin-top: 1px"></i>
      </a>
    </span>
  </div>
</template>
<script>
import { post, fetch, Del, put } from "@/ask/axios";
import  EventBus  from "@/ask/eventBus";
export default {
  props: {
    thWorkDays:  Array,
    startAirport: Array,
    endAirport: Array,
    parmaData: Object,
    result:Object,
    isCheckSortBy:Boolean,
  },
  data() {
    return {
      // 因为是v-if 所以重新加载时会变成初始值
      arrivalType: this.parmaData.arrivalType === 1 ? true : false,
      startCode3: [],
      endCode3: [],
      thDays: [],
      airlineCode2:[],
      airlinelist:[],
      airlineCode2list:[],
      airlineOrigin:[],
      airlineOriginList:[],
      showMore:true,
      toleNum:5,
      showOrigin:true,
      originNum:5,
      saveState:false,
      checkEnquiryEd: true,
      Results:null,
      checkAirCount:0,
      checkOreCount:0
    };
  },
  created() {
    //"this.startAirport===",this.startAirport,);
    if(!this.isCheckSortBy){//判断是否点击了sort by筛选
      this.airlineOriginList = this.startAirport;
      this.airlineOrigin = this.startAirport
      //this.startCode3 = this.startAirport;
      this.endCode3 = this.endAirport;
      this.thDays = this.thWorkDays;
      this.airlineCode2list = this.result.Airline;
      let codeList=[];
      this.result.Airline.filter(function (elem) {
        codeList.push(elem.Code)
          return codeList;
      })
      this.airlinelist=codeList;
    }else{
      let obj = JSON.parse(localStorage.getItem('historyList'));
     //console.log("this.result.arrivalTypeState===",this.result.arrivalTypeState);
      this.airlineOriginList =this.result.oldOrigin?this.result.oldOrigin:this.startAirport;
      this.airlineOrigin = this.result.destlist?this.result.destlist:this.startAirport
      this.airlineCode2list = this.result.oldAirline?this.result.oldAirline:this.result.Airline;
      this.airlinelist=this.result.linelist?this.result.linelist:this.arrayforEach(this.airlineCode2list);
       this.endCode3 = this.endAirport;
      this.thDays = this.thWorkDays;
      this.checkAirCount = 1;
      this.checkOreCount = 1;
      this.arrivalType = this.result.arrivalTypeState == 1 ? true:false
    }
    
  },
  methods: {
    //点击Origin的更多more
    clickMoreOri(){
        this.showOrigin=this.showOrigin==true?false:true;
        this.originNum=this.showOrigin==true?5:this.airlineOriginList.length;
    },
    //点击Airline的更多more
    clickMore(){
        this.showMore=this.showMore==true?false:true;
        this.toleNum=this.showMore==true?5:this.airlineCode2list.length;
    },
    arrayforEach(array){
      let list = []
      if(array){
        array.filter(function (item) {
          list.push(item.Code)
          return list;
        })
      }
      return list
    },
     onlyRoute(){
       let that =this
       let type
       let newList =[]
       if(this.arrivalType){
         this.arrivalType=true
          type = 1
       }else{
         this.arrivalType=false
         type = ""
       }
       this.$emit("getarrivalType", type);
       //去重
       this.airlineOrigin=this.queryfirstValue(this.airlineOrigin);
       this.airlinelist=this.queryfirstValue(this.airlinelist);
      //选择直达的时候要带上起始机场和航司的条件
       
        let obj = JSON.parse(localStorage.getItem('historyList'));
       // console.log("kanuoxfsda[]][][][",this.result,obj);
          obj.List.filter(function(elem){
              elem.showFee = false;
              elem.showleft = true;
                if(type == 1){
                    if(that.airlineOrigin.includes(elem.StartAirPortCode3) && that.airlinelist.includes(elem.AirCompanyCode2) && elem.AirArrivalType==1){
                      newList.push(elem);
                    }
                  }else{
                    if(that.airlineOrigin.includes(elem.StartAirPortCode3) && that.airlinelist.includes(elem.AirCompanyCode2)){
                      newList.push(elem);
                    }
                  }
            
          });
           this.$emit("newList", newList);
    },
    //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
    queryfirstValue(val){
          val = val.filter(function(item, index, arr) {
              return arr.indexOf(item, 0) === index;
          });
          return val
    },
    queryAirLine(val,item) {
      let newList =[];//左侧栏筛选之后的结果集
      let type
       if(this.arrivalType){
         this.arrivalType=true
          type = 1
       }else{
         this.arrivalType=false
         type = ""
       }
      if(val==2){//Origin
        if(item){
          this.airlineOrigin=item.split();
        }
        //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
          
          this.airlineOrigin=this.queryfirstValue(this.airlineOrigin);
        this.sortQuery(this.airlineOrigin,this.airlinelist,type);
          this.result.List.filter(function(elem){
              if(elem.showleft){
                newList.push(elem);
              }
            })
             this.checkOreCount=1
      }
      if(val==3){//Airline
        if(item){
          this.airlinelist = item.split();
        }
        this.airlinelist=this.queryfirstValue(this.airlinelist);
        //console.log("hahahaha888888----",this.airlinelist);
        this.sortQuery(this.airlineOrigin,this.airlinelist,type);
        this.result.List.filter(function(elem){
          if(elem.showleft){
            newList.push(elem);
          }
        })
        this.checkAirCount=1
      }
       this.$emit("newList", newList);

    },
    getSortQueryInArr(val,item){
      var that = this
      var isCunZaiObj = {
        'isCunzai': false,
        'indexKey': '0',
      }
      if(val==3){
          for(var i = 0; i < that.airline.length; i++){
        var citem = that.airline[i];
        if(citem.Code == item.Code){
          isCunZaiObj = {
            'isCunzai': true,
            'indexKey': i
          }
          break;
        }
      }
      }
      if(val==2){
          for(var i = 0; i < that.startAirport.length; i++){
        var citem = that.startAirport[i];
        if(citem == item){
          isCunZaiObj = {
            'isCunzai': true,
            'indexKey': i
          }
          break;
        }
      }
      }

      return isCunZaiObj
    },
    sortQuery(list,item,type){
       this.$emit("sort", {
        startCode3: list,//this.airlineOrigin,//起始地
        // endCode3: this.endCode3,
        // thDays: this.thDays,
         arrivalType: type,//是否直达
        airlineCode2: item //this.airlinelist//机场
      });
    },
    // QueryAirline(){
    //   this.$emit("sort", {
    //     airlineCode2: this.airlinelist
    //   });
    // },
    onlyTrans(field, item) {
      let listAir = this.arrayforEach(this.airlineCode2list)
     // this[field] = item.split();
     this.airlineOrigin=item.split();
     //let listAir = this.arrayforEach(this.airlineCode2list)
      this.sortQuery(this.airline,'');
      let codeList=[];
        this.result.List.filter(function (elem) {
          if(elem.showleft){
            if(listAir.includes(elem.AirCompanyCode2)){
              codeList.push(elem.AirCompanyCode2)
              return codeList;
            }
          }
        })
      this.airlinelist=codeList
      this.sortQuery('',item.split());
    },
    //点击左侧all
    AllTrans(val) {
      let listAir = this.arrayforEach(this.airlineCode2list)
      var that = this;
        let codeList=[];
       let codeList11=[];
       let newList = [];
        let type
       if(this.arrivalType){
         this.arrivalType=true
          type = 1
       }else{
         this.arrivalType=false
         type = ""
       }
       
       debugger
      if(val==3){//Origin
       if(this.checkAirCount == 0){
           this.sortQuery(this.airlineOriginList,'',type);
            this.result.List.filter(function (elem) {
              if(elem.showleft){
                if(that.airlineOriginList.includes(elem.StartAirPortCode3)){
                  newList.push(elem);
                  codeList.push(elem.AirCompanyCode2)
                  codeList11.push(elem.StartAirPortCode3)
                  return codeList,codeList11;
                }
              }
            })
            
            if(!this.isCheckSortBy){
              this.airlinelist=listAir
            }else{
              this.airlinelist=this.result.linelist//this.result.destlist
            }
            // this.airlinelist=listAir
            this.airlineOrigin=this.airlineOriginList
       }else{
          this.sortQuery('',this.airlinelist,type);
            this.result.List.filter(function (elem) {
              if(elem.showleft){
                if(that.airlinelist.includes(elem.AirCompanyCode2)){
                  newList.push(elem);
                  codeList.push(elem.AirCompanyCode2)
                  codeList11.push(elem.StartAirPortCode3)
                  return codeList,codeList11;
                }
              }
            })
            
             if(!this.isCheckSortBy){
               //this.airlinelist=this.queryfirstValue(codeList);
              this.airlinelist=this.airlinelist
            }else{
              if(this.airlinelist.length == this.airlineCode2list.length){
                  this.airlinelist = this.queryfirstValue(codeList);
              }else{
                  this.airlinelist=this.airlinelist//this.result.destlist
              }
              
            }
            // this.airlinelist=listAir
            this.airlineOrigin=this.airlineOriginList
       }
   
      }
      if(val==2){//Airline
      //没有选中和选中only的时候
      if(this.checkOreCount == 0){
        this.sortQuery('',listAir,type);
        this.result.List.filter(function (elem) {
          if(elem.showleft){
            if(listAir.includes(elem.AirCompanyCode2)){
              newList.push(elem);
              codeList.push(elem.StartAirPortCode3)
              codeList11.push(elem.AirCompanyCode2)
              return codeList,codeList11;
            }
          }
        })
        // this.airlineOrigin=this.airlineOrigin
        if(!this.isCheckSortBy){
              this.airlineOrigin=this.airlineOrigin
            }else{
              this.airlineOrigin=this.result.destlist//this.result.destlist
            }
        this.airlinelist=listAir
      }else{
        this.sortQuery(this.airlineOrigin,'',type);
        this.result.List.filter(function (elem) {
          if(elem.showleft){
            if(that.airlineOrigin.includes(elem.StartAirPortCode3)){
              newList.push(elem);
              codeList.push(elem.StartAirPortCode3)
              codeList11.push(elem.AirCompanyCode2)
              return codeList,codeList11;
            }
          }
        })
        // this.airlineOrigin=this.airlineOrigin
        if(!this.isCheckSortBy){
              this.airlineOrigin=this.airlineOrigin
              //this.airlineOrigin=this.queryfirstValue(codeList);
            }else{
              if(this.airlineOrigin.length == this.airlineOriginList.length){
                  this.airlineOrigin = codeList
              }else{
                this.airlineOrigin=this.airlineOrigin//this.result.destlist
              }
              
            }
        this.airlinelist=listAir
      }
      }
      //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
        this.airlineOrigin=this.queryfirstValue(this.airlineOrigin);
        this.airlinelist=this.queryfirstValue(this.airlinelist);
      //console.log("all集合new======",newList);
      this.$emit("newList", newList);
    },
  },
};
</script>
<style scoped>
.dataLeft {
  width: 120px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 1.5%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.dataLeft h4 {
  font-size: 12px;
  background-color: #f8f8f8;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
}
.dataLeft h4 a {
  color: #004FB1;
  float: right;
}
.chkMode {
  padding: 10px 20px;
}
.cksort {
  font-size: 13px !important;
  line-height: 14px;
  color: black;
}
.dataLeft label {
  display: block;
  line-height: 30px;
  margin-right: 0px !important;
  width: 80%;
}
.transType {
  position: relative;
  display: block;
  width: 100%;
}
.onlyTrans {
  color: #004FB1;
  display: none;
  position: absolute;
  font-size: 12px;
  line-height: 25px;
  top: 0px;
  right: 0px;
}
.transType:hover .onlyTrans {
  display: inline-block;
}
.moreClass{
  margin: 10px 0px 20px 20px;
  display: block;
  color: #004FB1;
}
.moreClass a{
  color: #004FB1;
}
</style>



// WEBPACK FOOTER //
// src/components/reception/air/result/dataLeft.vue